import React from "react";
import { Row, Col } from "react-bootstrap";
import Page from "../common/page/Page.js";
import useTranslationAuthenticationUi from "./useTranslationAuthenticationUi.js";
import useShowLoader from "../common/loading-widgets/useShowLoader.js";
import ConnectionModeSignUp from "./ConnectionModeSignUp.js";


export default function ConnectionModeSignUpPage() {
  const { t, loading: tLoading } = useTranslationAuthenticationUi();
  useShowLoader(tLoading, "ConnectionModeSignUpPage");
  if (tLoading) return null;

  return (
    <div className="ConnectionModeSignUpPage">
      <Page>
        <Page.Title
          text={t("authentication-ui:registration_method")}
          loading={tLoading}
        />
        <Page.Content>
          <Row>
            <Col>
              <ConnectionModeSignUp/>
            </Col>
          </Row>
        </Page.Content>
      </Page>
    </div>
  );
}
